import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import axios from 'axios'
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import infiniteScroll from "vue-infinite-scroll";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'animate.css';


Vue.filter("timeformat", function(timestamp, mode) {
	if (!timestamp) return "-";
	const date = new Date(timestamp);
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	let hour = date.getHours();
	let minute = date.getMinutes();
	let second = date.getSeconds();

	month = month.toString().padStart(2, "0");
	day = day.toString().padStart(2, "0");
	hour = hour.toString().padStart(2, "0");
	minute = minute.toString().padStart(2, "0");
	second = second.toString().padStart(2, "0");

	if (mode === "short") {
		return `${year}/${month}/${day}`;
	} else if (mode === "timeonly") {
		return `${hour}:${minute}`;
	} else if (mode === "DateTime") {
		return `${month}月${day}日`;
	} else if (mode === "micLength") {
		return `${minute}:${second}`
	} else if (mode === "poster") {
		return `${month}/${year}`
	} else if (mode === "poster1") {
		return `${year}-${month}`
	} else if (mode === "posterDate") {
		return `${day}`
	} else if (mode === "month") {
		return `${month}`
	}  else if (mode === "shortData") {
		return `${year}/${month}/${day}/${hour}:${minute}`
	} else {
		return `${year}/${month}/${day}/${hour}:${minute}:${second}`;
	}
});

Vue.use(ElementUI, {locale})
Vue.use(VideoPlayer);
Vue.prototype.$layer = layer(Vue);
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  // store,
}).$mount('#app')

Vue.use(ElementUI)
Vue.use(VideoPlayer)
Vue.use(infiniteScroll)
